import { ImageIcon, Video, Wand2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const MODES = [
  { key: "create", label: "Create image", icon: ImageIcon },
  { key: "edit", label: "Edit image", icon: Wand2 },
  { key: "video", label: "Video", icon: Video },
];

export function StudioTabs({ mode, onChange, modes = MODES }) {
  return (
    <div className="flex gap-1 rounded-full border sm:w-fit border-white/[0.08] bg-ink-900 p-1" role="tablist" data-testid="studio-tabs">
      {modes.map(({ key, label, icon: Icon }) => (
        <button key={key} type="button" role="tab" aria-selected={mode === key} onClick={() => onChange(key)} data-testid={`studio-tab-${key}`}
          className={cn("flex h-9 min-w-0 flex-1 items-center justify-center gap-2 rounded-full px-2 text-sm transition-colors duration-200 sm:flex-none sm:px-4",
            mode === key ? "bg-white text-ink-950" : "text-zinc-400 hover:bg-white/[0.06] hover:text-zinc-100")}>
          <Icon className="hidden h-4 w-4 sm:block" /> <span className="truncate">{label}</span>
        </button>
      ))}
    </div>
  );
}
